import { useEffect } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { Dayjs } from 'dayjs';
import { getDateString } from '../../utils/date-helpers';

export const useViewEventOnCalendar = ({
  selectedEventIds,
  startHour,
  eventCardRef,
}: {
  selectedEventIds: (string | undefined)[] | undefined;
  startHour?: string | Dayjs | null | undefined;
  eventCardRef?: React.RefObject<HTMLDivElement | HTMLButtonElement | null>;
}) => {
  const navigate = useNavigate();
  const search = useSearch({ strict: false });
  const isFocusedEvent = !!search.eventId && !!selectedEventIds?.includes(search.eventId);

  const viewOnCalendar = (eventId: string | undefined, eventDate: string | undefined) => {
    if (!eventId || !eventDate) return;
    navigate({
      to: `/schedule/calendar`,
      search: { eventId, currentDate: getDateString(eventDate) },
    });
  };

  const removeEventIdInUrl = () => {
    navigate({
      to: `/schedule/calendar`,
      search: { ...search, eventId: undefined },
    });
  };

  // Auto-scroll calendar to position on initial load
  useEffect(() => {
    if (isFocusedEvent && startHour) {
      // Delay to ensure DOM is rendered
      const timeoutId = setTimeout(() => {
        if (startHour && eventCardRef?.current) {
          eventCardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        }
      }, 500);

      return () => clearTimeout(timeoutId);
    }

    return undefined;
  }, [isFocusedEvent, startHour, eventCardRef]);

  return { viewOnCalendar, removeEventIdInUrl, isFocusedEvent, eventCardRef };
};
